// extracted by mini-css-extract-plugin
module.exports = {"RV-D":"D_RV-D__Weirf"};